import { createContext } from 'react';
import AcceptedActions from '../reducer/AcceptedActions';
import AppState from '../reducer/AppState';

export const AppStateContext = createContext<AppState>(null!);
export const AppDispatchContext = createContext<React.Dispatch<AcceptedActions>>(null!);